import type { FC } from 'react';
import { memo } from 'react';
import { Link } from 'react-router-dom';

import useGaTracker from '../components/PageTracking';
import useSeo from '../components/useSeo';

const NoMatch: FC = memo(() => {
  useGaTracker();
  useSeo({
    title: 'Siden findes ikke | Toft Ejendomme',
    description: 'Siden findes ikke. Gå til forsiden eller se vores ejendomme i Silkeborg.',
    path: '/404',
    noIndex: true,
  });

  return (
    <section className="editorial-section">
      <div className="section-wrap">
        <div className="empty-state fade-in">
          <span className="eyebrow">404</span>
          <h1>Siden findes ikke</h1>
          <p>
            Beklager, men den side du leder efter eksisterer ikke. Den kan være flyttet, slettet eller
            have fået en ny adresse.
          </p>

          <div className="empty-state__actions">
            <Link className="site-btn site-btn--primary" to="/">
              Gå til forsiden
            </Link>
            <Link className="site-btn site-btn--outline" to="/ejendomme">
              Se vores ejendomme
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
});

NoMatch.displayName = 'NoMatch';

export default NoMatch;
